import { TabledRepeat } from "lib/@components/tabled-repeat/tabled-repeat"
import { GroupRow } from "./group-row"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

const tableHeaders = [
    { title: "Group Title" },
    { title: "Schedules" },
    { title: "Type" },
    { title: "Status" },
    { title: "" },
]

export function GroupTable() {
    const { projectGroups } = useBoundContext()
    return (
        <TabledRepeat
            items={projectGroups}
            itemPass="group"
            itemComponent={<GroupRow />}
            tableHeaders={tableHeaders}
            paged
            alternating={false}
        />
    )
}
